<div class="wrapper">
  <div
    class="shipping-date-container"
    [class.readonly]="readonly"
    [class.loading]="isLoading"
    (click)="onContainerClick()"
  >
    <unicon-product-option-chip
      class="flex-none min-w-[70px]"
      [product]="{ businessLineName: businessLineName }"
    />

    <div class="date-section">
      <ui-icon name="calendar" fill="neutrals-500" m-size="17" size="17" />
      <span class="date-text">{{ formattedDate }}</span>
    </div>

    <ui-icon
      *ngIf="!readonly && currentStartDateTime && !isLoading"
      name="edit"
      fill="neutrals-500"
      m-size="17"
      size="17"
    />
    <mat-spinner
      *ngIf="isLoading"
      diameter="16"
      class="loading-spinner"
    ></mat-spinner>
  </div>

  <!-- Calendario inline -->
  <div
    *ngIf="showCalendar"
    class="calendar-inline-container"
    (click)="$event.stopPropagation()"
  >
    <mat-calendar
      class="bg-neutrals-0 rounded-[8px] w-full max-w-full"
      [(selected)]="selectedDate"
      [minDate]="minDate"
      [startAt]="selectedDate || minDate"
      (selectedChange)="onDateChange($event)"
    ></mat-calendar>

    <div class="flex justify-center mt-4">
      <button
        type="button"
        class="bg-unicon-yellow-100 rounded-[8px] px-6 py-2 disabled:bg-[#A9BCD9] disabled:cursor-not-allowed"
        [disabled]="!selectedDate || isLoading"
        (click)="confirmDateSelection(); $event.stopPropagation()"
      >
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          [textColor]="selectedDate ? 'primary-700' : 'neutrals-0'"
          font-weight="semibold"
        >
          Seleccione
        </ui-paragraph>
      </button>
    </div>
  </div>
</div>
